import { useTranslation } from "react-i18next";
import { Card, CardText, CardBody, CardTitle, Button } from "reactstrap";
import TokenPriceState from "./tokenPriceState";
import { getTokenInfo } from "utils/getters";
import { addComma } from "utils/Format";
import LottieLogo from "components/pages/lottie";
import { logoOptions } from "constants/lotties";
import { COINNIK_MARKET_URL_BASE_TOKENS } from "configs/constants";

const DetailInfo = ({ allData, informationTitle }: any) => {
  const { t } = useTranslation();

  const {
    market_cap_rank,
    market_cap,
    price_change_percentage_24h,
    price_change_percentage_7d_in_currency,
  } = allData;
  const bestBuy = getTokenInfo(allData.symbol.toUpperCase(), "bestBuy", "TMN");
  const bestSell = getTokenInfo(
    allData.symbol.toUpperCase(),
    "bestSell",
    "TMN"
  );
  const data = [
    {
      name: "Ranking in the digital currency market",
      key: market_cap_rank,
      active: false,
    },
    { name: "Total market volume", key: market_cap, active: false },
    {
      name: bestBuy && allData ? "Buy price (Tomans)" : "",
      key: allData ? bestBuy : null,
      active: false,
    },
    {
      name: bestBuy && allData ? "Sell price (Tomans)" : "",
      key: allData ? bestSell : null,
      active: false,
    },
    { name: "24-hour change", key: price_change_percentage_24h, active: true },
    {
      name: "Changes in the last 7 days",
      key: price_change_percentage_7d_in_currency,
      active: true,
    },
  ];

  return (
    <div className="mt-md-n7">
      <Card className="shadow border-radius-1 detail-item-height">
        <CardBody>
          <CardTitle className="pb-4">
            <span className="fs-5 fw-bold title-bordre-bottom text-secondary-two-light">
              {t(informationTitle ? informationTitle : "shiba")}
            </span>
          </CardTitle>
          <div>
            {data.length ? (
              data.map((item) => (
                <ListItem
                  name={t(item.name)}
                  value={
                    item.active ? (
                      <TokenPriceState
                        value={item.key.toFixed(2)}
                        indicatorType="text"
                      />
                    ) : (
                      addComma(Number(item.key))
                    )
                  }
                />
              ))
            ) : (
              <LottieLogo options={logoOptions} />
            )}
            <div className="d-flex justify-content-center pt-5">
              <a
                href={
                  COINNIK_MARKET_URL_BASE_TOKENS +
                  allData.symbol.toUpperCase() +
                  "_TMN"
                }
              >
                <Button size="lg" color="warning " className="text-light">
                  {t("Quick trading")}
                </Button>
              </a>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};
export default DetailInfo;

const ListItem = ({ name, value }: any) => (
  <div className=" d-flex flex-column">
    {name.length ? (
      <CardText className="d-flex justify-content-between pb-4">
        <span className="text-secondary-one-light">{name}</span>
        <span className="text-dark">{value}</span>
      </CardText>
    ) : (
      <> </>
    )}
  </div>
);
